module.exports = __webpack_public_path__ + "public/img/pic_b.2e4a153a.png";